// src/components/ui/CardContent.jsx
import React from 'react';

const CardContent = ({ children }) => {
  return <div className="p-6">{children}</div>;
};

export default CardContent;